import { useContext, useEffect } from 'react';
import AppContext from '@context';
import { getByStatus } from '@services/journeys';
import { isAllowedShowList } from '@utils/ListJourneysWaitingConfirmDelivery';

const useLoadListWaitingConfirmDelivery = (
  type: 'onload' | 'lazy' = 'lazy',
) => {
  const { dispatch } = useContext(AppContext);
  const fetchListConfirmDelivery = async () => {
    dispatch({ type: 'journeys_waiting_confirm_delivery_loading' });

    if (isAllowedShowList()) {
      try {
        const response = await getByStatus('done_by_trucker');

        dispatch({
          type: 'journeys_waiting_confirm_delivery_load_success',
          payload: {
            data: response,
          },
        });

        if (response.length) {
          dispatch({
            type: 'ui_modal_journey_waiting_confirm_delivery_set_show',
            payload: {
              isShow: true,
            },
          });
        }
      } catch (error) {
        dispatch({
          type: 'journeys_waiting_confirm_delivery_load_error',
        });
      }
    }
  };

  useEffect(() => {
    if (type === 'onload') {
      fetchListConfirmDelivery();
    }
  }, []);

  return { fetchListConfirmDelivery };
};

export default useLoadListWaitingConfirmDelivery;
